import script from "./kanbaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./kanbaTable.vue?vue&type=script&setup=true&lang=js"

import "./kanbaTable.vue?vue&type=style&index=0&id=60462702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60462702"]])

export default __exports__